(function(){
  var root = document.getElementById('lp3'); if(!root) return;
  var SIZE_KEY = 'wb_lp3_size';
  var sizeLabels = {1:'38–42mm', 2:'44–49mm'};
  var currentSize = 1;
  try { currentSize = parseInt(localStorage.getItem(SIZE_KEY)||'1',10) || 1; } catch(e){}
  var cartCount = 0;
  var bar = document.getElementById('lp3-bar');
  var toast = document.getElementById('lp3-toast');
  var toastT;

  function showToast(msg){
    toast.textContent = msg; toast.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function(){ toast.classList.remove('is-on'); }, 2600);
  }

  /* ---- size picker ---- */
  function sizeMatches(val, size){
    if(!val) return false;
    var v = String(val).toUpperCase();
    return size === 1 ? (v.indexOf('38')===0 || v.indexOf('40')===0 || v.indexOf('41')===0) : (v.indexOf('44')===0 || v.indexOf('45')===0 || v.indexOf('46')===0 || v.indexOf('49')===0);
  }
  function applySize(size, silent){
    currentSize = size;
    try { localStorage.setItem(SIZE_KEY, String(size)); } catch(e){}
    root.querySelectorAll('[data-lp3-size]').forEach(function(b){
      var on = parseInt(b.getAttribute('data-lp3-size'),10)===size;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on?'true':'false');
    });
    root.querySelectorAll('[data-lp3-size-label]').forEach(function(el){ el.textContent = sizeLabels[size]; });
    root.querySelectorAll('[data-lp3-card]').forEach(refreshCard);
    if(!silent) showToast('Size set to ' + sizeLabels[size] + ' for every band');
  }
  root.querySelectorAll('[data-lp3-size]').forEach(function(b){
    b.addEventListener('click', function(){
      applySize(parseInt(b.getAttribute('data-lp3-size'),10), b.hasAttribute('data-lp3-scroll-after'));
      if(b.hasAttribute('data-lp3-scroll-after')){ var t = document.getElementById('lp3-bands'); if(t) t.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
  root.querySelectorAll('[data-lp3-change-size]').forEach(function(b){
    b.addEventListener('click', function(){
      var el = document.getElementById('lp3-size');
      el.scrollIntoView({behavior:'smooth', block:'center'});
      el.style.boxShadow = '0 0 0 3px rgba(184,149,106,.55)'; setTimeout(function(){ el.style.boxShadow=''; }, 1600);
    });
  });

  /* ---- cards ---- */
  function cardData(card){
    if(card._lp3) return card._lp3;
    var variants = [];
    try { variants = JSON.parse(card.querySelector('[data-lp3-variants]').textContent); } catch(e){}
    var d = {
      variants: variants,
      sizeIdx: parseInt(card.getAttribute('data-size-idx'),10),
      colorIdx: parseInt(card.getAttribute('data-color-idx'),10),
      color: null
    };
    var on = card.querySelector('[data-lp3-chip].is-on');
    d.color = on ? on.getAttribute('data-value') : null;
    card._lp3 = d; return d;
  }
  function optVal(v, idx){ return idx===0 ? v.o1 : idx===1 ? v.o2 : idx===2 ? v.o3 : null; }
  function pickVariant(card){
    var d = cardData(card);
    var list = d.variants.filter(function(v){
      var okColor = d.colorIdx < 0 || !d.color || optVal(v, d.colorIdx) === d.color;
      var okSize = d.sizeIdx < 0 || sizeMatches(optVal(v, d.sizeIdx), currentSize);
      return okColor && okSize;
    });
    return list.find(function(v){ return v.available; }) || list[0] || null;
  }
  function refreshCard(card){
    var d = cardData(card);
    var v = pickVariant(card);
    if((!v || !v.available) && !d.userPicked && d.colorIdx > -1){
      /* the default color is sold out in this size: quietly start on the first color that is in stock */
      var chips = card.querySelectorAll('[data-lp3-chip]');
      for(var i=0;i<chips.length;i++){
        var val = chips[i].getAttribute('data-value');
        var alt = d.variants.find(function(x){ return optVal(x, d.colorIdx) === val && x.available && (d.sizeIdx < 0 || sizeMatches(optVal(x, d.sizeIdx), currentSize)); });
        if(alt){
          chips.forEach(function(c){ c.classList.remove('is-on'); c.setAttribute('aria-selected','false'); });
          chips[i].classList.add('is-on'); chips[i].setAttribute('aria-selected','true');
          d.color = val; v = alt; break;
        }
      }
    }
    var btn = card.querySelector('[data-lp3-add]');
    var label = card.querySelector('[data-lp3-add-label]');
    var price = card.querySelector('[data-lp3-price]');
    var img = card.querySelector('[data-lp3-img]');
    var cname = card.querySelector('[data-lp3-color-name]');
    if(cname && d.color) cname.textContent = d.color.replace(/^(Perla|Nova|Atlanta|Sorelle|Kyra|Themis|Terra|Stella|Granum|Arya|Kyoto|Tokyo|Iola)\s+/i,'');
    if(!v){ btn.setAttribute('disabled','disabled'); label.textContent = 'Sold out'; return; }
    btn.removeAttribute('disabled');
    if(!btn.classList.contains('is-added')) label.textContent = root.getAttribute('data-add-label') || 'Add to my set';
    price.innerHTML = (v.compare ? '<s>'+v.compare+'</s>' : '') + '<span>'+v.price+'</span>';
    if(img && v.img && img.getAttribute('src') !== v.img){ img.style.opacity = .35; img.onload = function(){ img.style.opacity = 1; }; img.src = v.img; }
    if(!v.available){ btn.setAttribute('disabled','disabled'); label.textContent = 'Sold out in this size'; }
    card._lp3.variant = v;
  }
  root.querySelectorAll('[data-lp3-card]').forEach(function(card){
    card.querySelectorAll('[data-lp3-chip]').forEach(function(chip){
      chip.addEventListener('click', function(){
        card.querySelectorAll('[data-lp3-chip]').forEach(function(c){ c.classList.remove('is-on'); c.setAttribute('aria-selected','false'); });
        chip.classList.add('is-on'); chip.setAttribute('aria-selected','true');
        cardData(card).color = chip.getAttribute('data-value'); cardData(card).userPicked = true;
        var b = card.querySelector('[data-lp3-add]'); b.classList.remove('is-added');
        refreshCard(card);
      });
    });
    card.querySelector('[data-lp3-add]').addEventListener('click', function(){ addToCart(card); });
    refreshCard(card);
  });

  /* ---- cart ---- */
  var cartSave = 0, cartCur = null;
  var giftIds = (root.getAttribute('data-gift-variants')||'').split(',').map(function(x){ return parseInt(x.trim(),10); }).filter(Boolean);
  var giftBusy = false;
  function fmtMoney(cents, cur){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency: cur, maximumFractionDigits: 2}).format(cents/100); } catch(e){ return (cents/100).toFixed(2) + ' ' + cur; }
  }
  function isGift(item){ return giftIds.indexOf(item.variant_id) > -1; }
  /* Free gifts ride along only while the set is complete (3+ bands). Added silently, removed silently. */
  function syncGifts(c){
    if(!giftIds.length || giftBusy) return Promise.resolve(c);
    var bands = 0; c.items.forEach(function(it){ if(!isGift(it)) bands += it.quantity; });
    var present = {}; c.items.forEach(function(it){ if(isGift(it)) present[it.variant_id] = it; });
    var ops = [];
    if(bands >= 3){
      var missing = giftIds.filter(function(id){ return !present[id]; });
      if(missing.length) ops.push(fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: missing.map(function(id){ return {id:id, quantity:1}; })})}));
      giftIds.forEach(function(id){ if(present[id] && present[id].quantity > 1) ops.push(fetch('/cart/change.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: present[id].key, quantity: 1})})); });
    } else {
      giftIds.forEach(function(id){ if(present[id]) ops.push(fetch('/cart/change.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: present[id].key, quantity: 0})})); });
    }
    if(!ops.length) return Promise.resolve(c);
    giftBusy = true;
    return Promise.all(ops).then(function(){ giftBusy = false; document.dispatchEvent(new CustomEvent('cart:build')); return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }); }).catch(function(){ giftBusy = false; return c; });
  }
  function fetchCount(){
    return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(syncGifts).then(function(c){
      var bands = 0; c.items.forEach(function(it){ if(!isGift(it)) bands += it.quantity; });
      cartCount = bands; cartSave = c.total_discount||0; cartCur = c.currency||null; renderBar(); return c;
    }).catch(function(){});
  }
  function addToCart(card){
    var d = cardData(card); var v = d.variant || pickVariant(card); if(!v) return;
    var btn = card.querySelector('[data-lp3-add]'); var label = card.querySelector('[data-lp3-add-label]');
    btn.classList.add('is-busy'); label.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: v.id, quantity: 1}]})
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); }).then(function(res){
      btn.classList.remove('is-busy');
      if(!res.ok){ label.textContent = 'Try again'; showToast(res.j && res.j.description ? res.j.description : 'Could not add. Please try again.'); return; }
      btn.classList.add('is-added'); label.textContent = 'Added ✓';
      setTimeout(function(){ btn.classList.remove('is-added'); label.textContent = 'Add another'; }, 2200);
      fetchCount().then(function(){
        var item = res.j && res.j.items ? res.j.items[0] : res.j;
        if(cartCount >= 3){
          /* third band in: open the theme cart so they can check out */
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:item, addToCartBtn:btn}}));
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
          var left = 3 - cartCount;
          showToast(cartCount + ' of 3 added. Add ' + left + ' more and the cheapest is free.');
        }
      });
    }).catch(function(){ btn.classList.remove('is-busy'); label.textContent = 'Try again'; });
  }

  /* ---- sticky bar ---- */
  var barTitle = bar.querySelector('[data-lp3-bar-title]'), barSub = bar.querySelector('[data-lp3-bar-sub]'), barBtn = bar.querySelector('[data-lp3-bar-btn]'), barSave = bar.querySelector('[data-lp3-bar-save]');
  function renderBar(){
    var n = Math.min(cartCount, 3);
    if(barSave){ if(cartSave > 0 && cartCur){ barSave.textContent = 'You save ' + fmtMoney(cartSave, cartCur); barSave.hidden = false; } else { barSave.hidden = true; } }
    bar.querySelectorAll('.lp3-bar__slot').forEach(function(s, i){
      s.classList.toggle('is-full', i < n && !(i === 2 && n >= 3));
      s.classList.toggle('is-free', i === 2 && n >= 3);
    });
    barBtn.classList.remove('is-go');
    onScroll();
    if(cartCount === 0){
      barTitle.textContent = 'Pick any 3 bands, pay for 2'; barSub.textContent = 'Cheapest one free at checkout';
      barBtn.textContent = 'Pick bands'; barBtn.setAttribute('href', '#lp3-bands'); barBtn.setAttribute('data-lp3-scroll','');
    } else if(cartCount < 3){
      var left = 3 - cartCount;
      barTitle.textContent = cartCount + ' of 3 in your set'; barSub.textContent = 'Add ' + left + ' more, cheapest is free';
      barBtn.textContent = 'Add ' + left + ' more'; barBtn.setAttribute('href', '#lp3-bands'); barBtn.setAttribute('data-lp3-scroll','');
    } else {
      barTitle.textContent = 'Set complete, 3rd band free'; barSub.textContent = (cartSave > 0 && cartCur) ? (cartCount + ' bands, ' + fmtMoney(cartSave, cartCur) + ' off') : (cartCount + ' bands, discount at checkout');
      barBtn.textContent = 'Checkout'; barBtn.setAttribute('href', '/checkout'); barBtn.removeAttribute('data-lp3-scroll'); barBtn.classList.add('is-go');
    }
  }
  /* The set bar shows once the hero is scrolled past, or as soon as there is a band in the set (counter always in view) */
  function onScroll(){
    var hero = root.querySelector('.lp3-hero');
    var past = hero ? (hero.getBoundingClientRect().bottom < 0) : true;
    var show = past || cartCount > 0;
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('lp3-has-bar', show);
  }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* smooth scroll to the grid */
  root.addEventListener('click', function(e){
    var a = e.target.closest('[data-lp3-scroll]'); if(!a) return;
    var t = document.getElementById('lp3-bands'); if(!t) return;
    e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'});
  });

  /* faq */
  root.querySelectorAll('[data-lp3-faq] .lp3-faq__q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.parentNode; var open = item.classList.toggle('is-open'); q.setAttribute('aria-expanded', open?'true':'false');
    });
  });

  /* keep the bar honest if the cart changes elsewhere (theme cart drawer qty changes) */
  document.addEventListener('cart:updated', function(){ fetchCount(); });
  document.addEventListener('cart:close', function(){ setTimeout(fetchCount, 200); });
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) fetchCount(); });
  window.addEventListener('pageshow', function(){ fetchCount(); });
  document.addEventListener('ajaxProduct:added', function(){ setTimeout(fetchCount, 300); });

  /* Ad-matched hero: /pages/3-for-2?v=key swaps headline, sub and hero images from the JSON map in section settings */
  try {
    var vkey = new URLSearchParams(location.search).get('v');
    var vmapEl = document.getElementById('lp3-variants-map');
    if(vkey && vmapEl){
      var vmap = JSON.parse(vmapEl.textContent || '{}'); var v = vmap[vkey];
      if(v){
        var t = root.querySelector('[data-lp3-v="title"]'); if(t && v.title) t.innerHTML = v.title;
        var sb = root.querySelector('[data-lp3-v="sub"]'); if(sb && v.sub) sb.textContent = v.sub;
        var id = root.querySelector('[data-lp3-v="img-d"]'); if(id && v.img_d){ id.removeAttribute('srcset'); id.src = v.img_d; }
        var im = root.querySelector('[data-lp3-v="img-m"]'); if(im && v.img_m){ im.src = v.img_m; }
      }
    }
  } catch(e){}

  applySize(currentSize, true);
  fetchCount();
})();
